import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import { ApiMembersEmployeeConditionSurveysShowResponseType } from "~/domains";

type RequestDataType = {
  id: string;
};

const request = async ({
  id,
}: RequestDataType): Promise<ApiMembersEmployeeConditionSurveysShowResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersEmployeeConditionSurveysShowResponseType>(
      `/api/members/employee_condition_surveys/${id}`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersEmployeeConditionSurveysShow = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApiMembersEmployeeConditionSurveysShowResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApiMembersEmployeeConditionSurveysShow", id],
    queryFn: () => request({ id }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
